// Hebrew number/date formats and palette lookups for the BI charts and tables.
const DASH = '—';
const PALETTE = ['#2f8f63', '#eda100', '#e87ba4', '#6250d6', '#eb6834'];
const compactFmt = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 2 });
const fullFmt = { format: (v) => new Intl.NumberFormat('he-IL', { maximumFractionDigits: 2 }).format(v).replace(/\u200e/g, '') };
const none = (v) => v === null || v === undefined || Number.isNaN(v);

export function money(v, { compact = true } = {}) {
  if (none(v)) return DASH;
  const body = (compact ? compactFmt : fullFmt).format(Math.abs(v));
  return `${v < 0 ? '-' : ''}₪${body}`;
}

export function qty(v, { compact = false } = {}) {
  if (none(v)) return DASH;
  return (compact ? compactFmt : fullFmt).format(v);
}

export const pct = (v) => (none(v) ? DASH : `${v > 0 ? '+' : ''}${fullFmt.format(v)}%`);
export const share = (v) => (none(v) ? DASH : `${fullFmt.format(v)}%`);

const KINDS = { money, qty, pct, share };
export function cell(v, kind) {
  if (none(v) || v === 0) return DASH;
  return KINDS[kind] ? KINDS[kind](v) : String(v);
}

const month = (m, style) =>
  new Intl.DateTimeFormat('he-IL', { month: style, timeZone: 'UTC' }).format(new Date(Date.UTC(2024, m - 1, 15)));
export const monthShort = (m) => month(m, 'short');
export const monthLong = (m) => month(m, 'long');

const readVar = (name) =>
  typeof document === 'undefined' ? '' : getComputedStyle(document.documentElement).getPropertyValue(name);

export function seriesColor(index, read = readVar) {
  const i = ((index % 5) + 5) % 5;
  return read(`--bi-c${i + 1}`).trim() || PALETTE[i];
}

// A key outside the order (an "other" bucket, a sixth slice) is the neutral grey, never a borrowed hue.
export function entityColor(key, order, read = readVar) {
  const i = order.indexOf(key);
  return i < 0 ? read('--bi-other').trim() || '#c1ccc2' : seriesColor(i, read);
}
